/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 11:07
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

// TODO: @HTML5 - Missing HTTPStatusEvent and URLRequest

// import HTTPStatusEvent = createjs.HTTPStatusEvent;
// import URLRequest = createjs.URLRequest;

export class HTTPErrorLOFactory extends BasicLogObjectFactory {
    public static GENERAL_TRACKING_HTTP_ERROR: number = 9001;
    public static GENERAL_TRACKING_SERVER_HTTP_ERROR: number = 9002;

    private static HTTP_ERROR: number = 9;

    private static PARAM_HTTP_CODE: string = "httpCode";
    private static PARAM_REQUEST_DATA: string = "requestData";
    private static PARAM_EVENT_DATA: string = "eventData";

    // private _statusEvent: HTTPStatusEvent;
    private _statusEvent: any;
    // private _req: URLRequest;
    private _req: any;
    private _requesDataKey: string;
    private _eventData: string;

    constructor(subErrorId: number, statusEvent: any, req: any, requesDataKey: string = "", eventData: string = null) {
        super();

        this._subErrorId = subErrorId;
        this._statusEvent = statusEvent;
        this._req = req;
        this._requesDataKey = requesDataKey;
        this._eventData = eventData;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, HTTPErrorLOFactory.HTTP_ERROR.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_URL, this._req.url);
        lo.logData.set(HTTPErrorLOFactory.PARAM_HTTP_CODE, this._statusEvent.status);

        if (this._req.data) {
            lo.logData.set(HTTPErrorLOFactory.PARAM_REQUEST_DATA, this._req.data[this._requesDataKey]);
        }

        if (this._eventData) {
            lo.logData.set(HTTPErrorLOFactory.PARAM_EVENT_DATA, this._eventData);
        }

        return lo;
    }
}
